export interface Hospital {
  id: number;
  name: string;
  address: string;
  sido: string;
  gugun: string;
  phone?: string;
  website?: string;
  lat: number | null;
  lng: number | null;
}

export const hospitals: Hospital[] = [
  {
    "id": 1,
    "name": "DMC조은안과의원",
    "address": "서울시 마포구 월드컵 북로 402 KGIT 센터 3층 323호",
    "sido": "서울",
    "gugun": "마포구",
    "phone": "02-6393-5375",
    "website": "http://www.dmceyeclinic.com/",
    "lat": 37.5800952104,
    "lng": 126.889059235
  },
  {
    "id": 3,
    "name": "강남 아이원스 안과",
    "address": "서울특별시 서초구 사평대로368, 5~6층",
    "sido": "서울",
    "gugun": "서초구",
    "phone": "02-593-3313",
    "website": "https://eyeonce.com/",
    "lat": 37.4965746,
    "lng": 127.0246219539
  },
  {
    "id": 4,
    "name": "강남도쿄안과 (구 강남푸른안과)",
    "address": "서울특별시 강남구 강남대로 442, 5층",
    "sido": "서울",
    "gugun": "강남구",
    "phone": "02-6956-8882",
    "website": "https://www.gangnam-tokyo.co.kr/",
    "lat": 37.496035027,
    "lng": 127.0290704116
  },
  {
    "id": 5,
    "name": "강남밝은명안과",
    "address": "서울특별시 서초구 서초4동1305-8 동일빌딩9층",
    "sido": "서울",
    "gugun": "서초구",
    "phone": "02-533-6363",
    "website": "http://www.abceye.com/",
    "lat": 37.5007185953,
    "lng": 127.0257612708
  },
  {
    "id": 6,
    "name": "강남밝은미소안과",
    "address": "서울특별시 강남구 강남대로 408, YBM강남센터 3층",
    "sido": "서울",
    "gugun": "강남구",
    "phone": "1544-2271",
    "website": "https://www.saveeye.co.kr/",
    "lat": 37.4992181985,
    "lng": 127.0275420113
  },
  {
    "id": 7,
    "name": "강남브랜드안과(인천점)",
    "address": "인천 부평구 시장로 32 2층, 3층",
    "sido": "인천",
    "gugun": "부평구",
    "phone": "1644-5595",
    "website": "https://brandeye.co.kr/html/pages/pc/main.php",
    "lat": 37.4947,
    "lng": 126.7235
  },
  {
    "id": 8,
    "name": "강남브랜드안과의원",
    "address": "서울 서초구 강남대로 519 3층, 8층, 9층",
    "sido": "서울",
    "gugun": "서초구",
    "phone": "1644-5595",
    "website": "https://brandeye.co.kr/",
    "lat": 37.5082880329,
    "lng": 127.0222059053
  },
  {
    "id": 9,
    "name": "강남서울밝은안과",
    "address": "서울특별시 강남구 강남대로 390 미진프라자 18층 (역삼동825 미진프라자 18층)",
    "sido": "서울",
    "gugun": "강남구",
    "phone": "1588-3882",
    "website": "https://www.smartlasik.co.kr/",
    "lat": 37.4978399532,
    "lng": 127.0285788463
  },
  {
    "id": 10,
    "name": "강남성모원안과",
    "address": "서울특별시 서초구 강남대로85길 5, 대유빌딩 2층",
    "sido": "서울",
    "gugun": "서초구",
    "phone": "02-521-1212",
    "website": "https://www.stmaryone.com/",
    "lat": 37.5073664113,
    "lng": 127.0225948119
  },
  {
    "id": 11,
    "name": "강남센트럴안과",
    "address": "서울특별시 강남구 테헤란로333, 신도벤처타워8~9층",
    "sido": "서울",
    "gugun": "강남구",
    "phone": "02-555-1369",
    "website": "https://centraleye.kr/",
    "lat": 37.5046966146,
    "lng": 127.0480133953
  },
  {
    "id": 12,
    "name": "강남아이오케이안과",
    "address": "서울특별시 서초구 강남대로491",
    "sido": "서울",
    "gugun": "서초구",
    "phone": "02-6949-0088",
    "website": "https://www.iokeyes.com/",
    "lat": 37.5060398196,
    "lng": 127.0232751533
  },
  {
    "id": 13,
    "name": "강남에이스안과",
    "address": "서울특별시 강남구 테헤란로151, 역삼하이츠빌딩2층",
    "sido": "서울",
    "gugun": "강남구",
    "phone": "02-564-1004",
    "website": "https://aceeyecenter.com/",
    "lat": 37.5009805028,
    "lng": 127.0361357724
  },
  {
    "id": 14,
    "name": "강남이룸안과",
    "address": "서울특별시 강남구 강남대로358, 강남358타워 B1층",
    "sido": "서울",
    "gugun": "강남구",
    "phone": "02-6952-0975",
    "website": "http://www.erumeye.co.kr/",
    "lat": 37.4950592366,
    "lng": 127.0297938723
  },
  {
    "id": 15,
    "name": "강남이오스안과",
    "address": "서울특별시 서초구 강남대로 355 (서초동), 삼성화재 서초사옥 18~20층",
    "sido": "서울",
    "gugun": "서초구",
    "phone": "02-3454-2080",
    "website": "https://www.eoseye.co.kr/",
    "lat": 37.4943664214,
    "lng": 127.0288293544
  },
  {
    "id": 16,
    "name": "강남큐브안과",
    "address": "서울특별시 강남구 선릉로703, H&S타워6층",
    "sido": "서울",
    "gugun": "강남구",
    "phone": "02-555-2080",
    "website": "https://cubeeye.kr/",
    "lat": 37.5176931768,
    "lng": 127.0407530933
  },
  {
    "id": 17,
    "name": "공덕안과",
    "address": "서울특별시 마포구 만리재로14, 한국사회복지회관 르네상스타워3층",
    "sido": "서울",
    "gugun": "마포구",
    "phone": "02-704-3088",
    "website": "http://seouleye.net/",
    "lat": 37.5438974054,
    "lng": 126.9528350393
  },
  {
    "id": 18,
    "name": "공안과",
    "address": "서울특별시 종로구 종로 19 르메이에르종로타운 311호",
    "sido": "서울",
    "gugun": "종로구",
    "phone": "02-733-5111",
    "website": "https://www.kongeye1938.co.kr/",
    "lat": 37.5708718508,
    "lng": 126.9756546539
  },
  {
    "id": 19,
    "name": "광교연세안과",
    "address": "경기 수원시 영통구 센트럴타운로 98 경현빌딩 301호",
    "sido": "경기",
    "gugun": "수원시 영통구",
    "phone": "031-8019-8081",
    "website": "http://www.gyonseieye.co.kr/",
    "lat": 37.2921312648,
    "lng": 127.0506935904
  },
  {
    "id": 20,
    "name": "광주굿모닝서울안과",
    "address": "광주광역시 서구 무진대로965",
    "sido": "광주",
    "gugun": "서구",
    "phone": "062-430-2020",
    "website": "http://goodmorningseouleye.com/",
    "lat": 35.1615431916,
    "lng": 126.8860631056
  },
  {
    "id": 21,
    "name": "구리성모안과",
    "address": "경기도 구리시 경춘로 239(인창동, 리맥스타운5층)",
    "sido": "경기",
    "gugun": "구리시",
    "phone": "031-554-7575",
    "website": "http://www.lasiknara.com/",
    "lat": 37.6015535357,
    "lng": 127.1417917294
  },
  {
    "id": 22,
    "name": "굿모닝백이안과",
    "address": "부산광역시 부산진구 중앙대로 724, 굿모닝백이안과 3층, 6층~8층",
    "sido": "부산",
    "gugun": "부산진구",
    "phone": "051-8620-102",
    "website": "https://102eye.com/",
    "lat": 35.1572265408,
    "lng": 129.0599563297
  },
  {
    "id": 23,
    "name": "굿모닝빛안과",
    "address": "울산광역시 남구 삼산로 266, 굿모닝클리닉 2~3층",
    "sido": "울산",
    "gugun": "남구",
    "phone": "052-707-2500",
    "website": "https://goodmorningeye.co.kr/",
    "lat": 35.5387906055,
    "lng": 129.3362837511
  },
  {
    "id": 24,
    "name": "굿모닝성모의원",
    "address": "부산광역시 부산진구 새싹로 2",
    "sido": "부산",
    "gugun": "부산진구",
    "phone": "051-809-3131",
    "website": "http://www.eyedoc.co.kr/",
    "lat": 35.1585657177,
    "lng": 129.0590366487
  },
  {
    "id": 25,
    "name": "굿모닝안과",
    "address": "울산광역시 남구 삼산로 254, 5~6층",
    "sido": "울산",
    "gugun": "남구",
    "phone": "052-267-0123",
    "website": "https://ulsanlasiktop.co.kr/",
    "lat": 35.5385285002,
    "lng": 129.3339508385
  },
  {
    "id": 26,
    "name": "그랜드비에스(BS)안과",
    "address": "부산광역시 부산진구 중앙대로664, 이랜드PEER빌딩3층",
    "sido": "부산",
    "gugun": "부산진구",
    "phone": "051-926-7582",
    "website": "http://www.grandbs-eye.com/",
    "lat": 35.1519822073,
    "lng": 129.0595970727
  },
  {
    "id": 27,
    "name": "글로벌비전안과의원",
    "address": "인천광역시 부평구 경원대로 1366, 스테이션타워 9층",
    "sido": "인천",
    "gugun": "부평구",
    "phone": "032-263-2020",
    "website": "https://globalvisioneye.co.kr/",
    "lat": 37.4909877489,
    "lng": 126.7206360004
  },
  {
    "id": 28,
    "name": "김안과병원(건양의료재단)",
    "address": "서울특별시 영등포구 영신로 136 (영등포동4가)",
    "sido": "서울",
    "gugun": "영등포구",
    "phone": "1577-2639",
    "website": "http://www.kimeye.com/",
    "lat": 37.5197361143,
    "lng": 126.9014841002
  },
  {
    "id": 29,
    "name": "김안과의원(마산회원)",
    "address": "경상남도 창원시 마산회원구 3·15대로669",
    "sido": "경남",
    "gugun": "창원시 마산회원구",
    "phone": "055-298-1177",
    "website": "http://www.eyeclinic.co.kr/",
    "lat": 35.2329230387,
    "lng": 128.5778262305
  },
  {
    "id": 30,
    "name": "김안과의원(평택)",
    "address": "경기도 평택시 중앙로 270 (합정동964-11)",
    "sido": "경기",
    "gugun": "평택시",
    "phone": "031-652-5161",
    "website": "https://www.kimeyeclinic.co.kr/",
    "lat": 36.9898927241,
    "lng": 127.112681748
  },
  {
    "id": 31,
    "name": "난초꽃피다안과의원",
    "address": "대구광역시 중구 달구벌대로 2127, S타워 7층",
    "sido": "대구",
    "gugun": "중구",
    "phone": "053-254-0975",
    "website": "https://xn--vb0b56bt3a14duy0bbukb4n.kr/",
    "lat": 35.865249,
    "lng": 128.5965791126
  },
  {
    "id": 32,
    "name": "누네빛안과",
    "address": "부산광역시 부산진구 부전로77, 누네메디타워7~13층",
    "sido": "부산",
    "gugun": "부산진구",
    "phone": "1800-7722",
    "website": "https://www.nunevit.com/",
    "lat": 35.1569447773,
    "lng": 129.0545222388
  },
  {
    "id": 35,
    "name": "눈높이안과",
    "address": "울산광역시 남구 삼산로 130",
    "sido": "울산",
    "gugun": "남구",
    "phone": "052-700-7582",
    "website": "http://www.kindeye.co.kr/",
    "lat": 35.5356145745,
    "lng": 129.3217609554
  },
  {
    "id": 36,
    "name": "눈사랑안과(대전)",
    "address": "대전광역시 서구 둔산2동 1166, 타임클리닉 2층/7층",
    "sido": "대전",
    "gugun": "서구",
    "phone": "1644-7500",
    "website": "http://www.eyelove75.com/",
    "lat": 36.3508277705,
    "lng": 127.3786429763
  },
  {
    "id": 37,
    "name": "눈시원안과",
    "address": "부산광역시 부산진구 범일로186, 4층",
    "sido": "부산",
    "gugun": "부산진구",
    "phone": "051-631-6622",
    "website": "http://www.nunseeone.com/",
    "lat": 35.1466802309,
    "lng": 129.0596225147
  },
  {
    "id": 38,
    "name": "눈애안과의원",
    "address": "서울특별시 광진구 아차산로 241, 연한빌딩",
    "sido": "서울",
    "gugun": "광진구",
    "phone": "02-6463-6288",
    "website": "http://www.oheye.co.kr/",
    "lat": 37.5405050771,
    "lng": 127.0701503047
  },
  {
    "id": 39,
    "name": "눈에미소안과",
    "address": "서울 강남구 강남대로 364 미왕빌딩 3층, 7층, 8층",
    "sido": "서울",
    "gugun": "강남구",
    "phone": "02-501-7725",
    "website": "https://www.eyemiso.com/",
    "lat": 37.4955529336,
    "lng": 127.0292922065
  },
  {
    "id": 40,
    "name": "눈에힘안과",
    "address": "서울특별시 구로구 시흥대로551, 광희빌딩5층",
    "sido": "서울",
    "gugun": "구로구",
    "phone": "02-2039-9322",
    "website": "https://nunehim.com/",
    "lat": 37.4825399426,
    "lng": 126.9002462983
  },
  {
    "id": 41,
    "name": "다봄안과",
    "address": "부산광역시 부산진구 가야대로 783, 성원메디칼빌딩 5층",
    "sido": "부산",
    "gugun": "부산진구",
    "phone": "051-806-0505",
    "website": "http://www.dabomeye.kr/",
    "lat": 35.1580642229,
    "lng": 129.0572336412
  },
  {
    "id": 42,
    "name": "대구안과의원",
    "address": "대구광역시 남구 월배로 468, 한영유니죤빌딩",
    "sido": "대구",
    "gugun": "남구",
    "phone": "053-651-2233",
    "website": "https://blog.naver.com/dgeye2025",
    "lat": 35.8346489025,
    "lng": 128.5559677249
  },
  {
    "id": 43,
    "name": "대구연세안과",
    "address": "대구광역시 수성구 수성로206",
    "sido": "대구",
    "gugun": "수성구",
    "phone": "053-626-8881",
    "website": "https://highnun.co.kr/",
    "lat": 35.8436536864,
    "lng": 128.6128994714
  },
  {
    "id": 44,
    "name": "대전성모안과",
    "address": "대전광역시 서구 계룡로 599, 601~602호",
    "sido": "대전",
    "gugun": "서구",
    "phone": "042-533-0078",
    "website": "http://www.tjsungmoeye.com/",
    "lat": 36.3413834011,
    "lng": 127.3860922039
  },
  {
    "id": 45,
    "name": "더(The)참안과",
    "address": "부산광역시 부산진구 중앙대로708, 부산파이낸스센터8층",
    "sido": "부산",
    "gugun": "부산진구",
    "phone": "051-802-8100",
    "website": "https://thecharmeye.com/",
    "lat": 35.1559896676,
    "lng": 129.0596400647
  },
  {
    "id": 46,
    "name": "데미안안과",
    "address": "경기도 화성시 병점노을4로 29, 5층(503~507호)",
    "sido": "경기",
    "gugun": "화성시",
    "phone": "031-8013-1234",
    "website": "https://www.demianeye.co.kr/",
    "lat": 37.2058707494,
    "lng": 127.0318937061
  },
  {
    "id": 47,
    "name": "드림성모안과",
    "address": "서울특별시 강남구 강남대로390, 미진프라자14층",
    "sido": "서울",
    "gugun": "강남구",
    "phone": "1588-9881",
    "website": "https://www.hellolasik.com/",
    "lat": 37.4978399532,
    "lng": 127.0285788463
  },
  {
    "id": 48,
    "name": "로운안과의원",
    "address": "대구광역시 달서구 월곡로260, 3층",
    "sido": "대구",
    "gugun": "달서구",
    "phone": "053-634-8575",
    "website": "https://www.rouneye.com/",
    "lat": 35.8177805237,
    "lng": 128.5393225268
  },
  {
    "id": 49,
    "name": "루원스마일안과의원",
    "address": "인천 서구 가정로 451, 8층 (가정동, 벨라미센텀시티)",
    "sido": "인천",
    "gugun": "서구",
    "phone": "032-710-3993",
    "website": "https://lu1smile.imweb.me/",
    "lat": 37.5252431578,
    "lng": 126.6731156657
  },
  {
    "id": 50,
    "name": "리지안안과",
    "address": "경기도 성남시 돌마로 68, 리지안안과의원 3층 (구미동)",
    "sido": "경기",
    "gugun": "성남시",
    "phone": "1588-4574",
    "website": "https://www.lijianeye.com/",
    "lat": 37.3496466239,
    "lng": 127.1095482081
  },
  {
    "id": 51,
    "name": "맑은눈안과의원",
    "address": "대전광역시 서구 청사로 148(둔산동939) 매그놀리아 1층",
    "sido": "대전",
    "gugun": "서구",
    "phone": "042-476-0075",
    "website": "https://www.clearlasik.co.kr/",
    "lat": 36.358283111,
    "lng": 127.3818100635
  },
  {
    "id": 52,
    "name": "(대구)메트로안과",
    "address": "대구광역시 수성구 달구벌대로 2360 (수성동3가)",
    "sido": "대구",
    "gugun": "수성구",
    "phone": "053-253-0037",
    "website": "https://www.metroeye.co.kr/",
    "lat": 35.8590646537,
    "lng": 128.6205269871
  },
  {
    "id": 53,
    "name": "명동성모안과",
    "address": "서울특별시 중구 을지로2가 199-4",
    "sido": "서울",
    "gugun": "중구",
    "phone": "02-319-9300",
    "website": "http://www.4eye.co.kr/",
    "lat": 37.5652229786,
    "lng": 126.9832853933
  },
  {
    "id": 54,
    "name": "문안과",
    "address": "경기 수원시 팔달구 정조로 762",
    "sido": "경기",
    "gugun": "수원시 팔달구",
    "phone": "031-251-1373",
    "website": "https://www.lasik4u.co.kr/",
    "lat": 37.2759083305,
    "lng": 127.0169258833
  },
  {
    "id": 55,
    "name": "밝은누리안과병원",
    "address": "대전광역시 서구 둔산로 61",
    "sido": "대전",
    "gugun": "서구",
    "phone": "042-485-6644",
    "website": "https://nurieye.co.kr/",
    "lat": 36.3515848,
    "lng": 127.3807573
  },
  {
    "id": 56,
    "name": "밝은눈안과병원",
    "address": "부산광역시 부산진구 가야대로 729",
    "sido": "부산",
    "gugun": "부산진구",
    "phone": "1670-3993",
    "website": "https://busan.bgneye.co.kr/",
    "lat": 35.1579058093,
    "lng": 129.0513573125
  },
  {
    "id": 57,
    "name": "밝은눈안과의원 잠실점",
    "address": "서울특별시 송파구 올림픽로 300, 롯데월드타워앤드롯데월드몰 월드타워동 11층",
    "sido": "서울",
    "gugun": "송파구",
    "phone": "1600-5770",
    "website": "https://www.bgneye.com/bgn_company/bgn.php",
    "lat": 37.5137129859,
    "lng": 127.1043018292
  },
  {
    "id": 58,
    "name": "밝은성모안과의원",
    "address": "서울특별시 강남구 테헤란로 110, 캠브리지빌딩 3층/16~18층",
    "sido": "서울",
    "gugun": "강남구",
    "phone": "02-2202-1515",
    "website": "https://www.oklasik.com/",
    "lat": 37.4980657285,
    "lng": 127.0293824134
  },
  {
    "id": 59,
    "name": "밝은성모안과의원(부산)",
    "address": "부산광역시 부산진구 중앙대로 723, 5~6층",
    "sido": "부산",
    "gugun": "부산진구",
    "phone": "051-804-1522",
    "website": "https://oklasikbusan.com/",
    "lat": 35.1571508002,
    "lng": 129.0573338885
  },
  {
    "id": 60,
    "name": "밝은세상 안과(부산)",
    "address": "부산시 부산진구 서면로74 아이온시티빌딩 8-11층",
    "sido": "부산",
    "gugun": "부산진구",
    "phone": "051-805-1100",
    "website": "http://www.iloveeye.co.kr/index.do",
    "lat": 35.1572181274,
    "lng": 129.0581349372
  },
  {
    "id": 61,
    "name": "밝은세상안과의원(서울)",
    "address": "서울시 강남구 선릉로 823 한양타운 2,6,7층",
    "sido": "서울",
    "gugun": "강남구",
    "phone": "02-3443-0880",
    "website": "https://www.iloveeye.com/index.do",
    "lat": 37.5256358141,
    "lng": 127.039342631
  },
  {
    "id": 62,
    "name": "밝은수안과의원",
    "address": "부산광역시 부산진구 가야대로781-1, SS메디컬빌딩 8~9층",
    "sido": "부산",
    "gugun": "부산진구",
    "phone": "051-808-1010",
    "website": "https://www.eyesoo.co.kr/",
    "lat": 35.1580218815,
    "lng": 129.0571161506
  },
  {
    "id": 63,
    "name": "밝은안과(경산)",
    "address": "경상북도 경산시 중방로 17, 세란빌딩 4층",
    "sido": "경북",
    "gugun": "경산시",
    "phone": "053-813-9944",
    "website": "https://eye4me.co.kr/",
    "lat": 35.8303320552,
    "lng": 128.7360759849
  },
  {
    "id": 64,
    "name": "밝은힐링안과의원",
    "address": "경상남도 창원시 성산구 상남로126, 10층",
    "sido": "경남",
    "gugun": "창원시 성산구",
    "phone": "055-719-2800",
    "website": "https://opht.xn--vb0b45v72i2ms.com/index.php",
    "lat": 35.2241064204,
    "lng": 128.6836402569
  },
  {
    "id": 65,
    "name": "밝음나눔안과(강남)",
    "address": "서울특별시 강남구 강남대로376, 8258빌딩2/6/14층",
    "sido": "서울",
    "gugun": "강남구",
    "phone": "02-556-8800",
    "website": "https://www.eyejun.co.kr/",
    "lat": 37.4965746,
    "lng": 127.0246219539
  },
  {
    "id": 66,
    "name": "밝음나눔안과(부천)",
    "address": "경기도 부천시 원미구 길주로 280, 프리머스 부천타워 7F",
    "sido": "경기",
    "gugun": "부천시 원미구",
    "phone": "032-710-7542",
    "website": "https://sharebrightvision.co.kr/branches/index.php",
    "lat": 37.5027724671,
    "lng": 126.7731792237
  },
  {
    "id": 67,
    "name": "밝음나눔안과(안양점)",
    "address": "경기도 안양시 만안구 안양로 307, 금상타워 7~8층",
    "sido": "경기",
    "gugun": "안양시 만안구",
    "phone": "031-360-7542",
    "website": "https://www.eyejun.co.kr/",
    "lat": 37.3992584093,
    "lng": 126.9205609511
  },
  {
    "id": 68,
    "name": "보다안과(대전)",
    "address": "대전 서구 둔산중로 50 파이낸스빌딩 5층",
    "sido": "대전",
    "gugun": "서구",
    "phone": "042-528-0079",
    "website": "http://bodaeye.com/",
    "lat": 36.35100009,
    "lng": 127.3871320472
  },
  {
    "id": 69,
    "name": "봄의약속안과",
    "address": "서울특별시 강동구 양재대로1570, 미래빌딩5층 봄의약속안과",
    "sido": "서울",
    "gugun": "강동구",
    "phone": "02-426-0020",
    "website": "https://vnp.kr/",
    "lat": 37.5456635685,
    "lng": 127.1432420722
  },
  {
    "id": 70,
    "name": "봄이오는안과의원",
    "address": "대구광역시 달성군 유가읍 테크노상업로 98",
    "sido": "대구",
    "gugun": "달성군",
    "phone": "053-614-7778",
    "lat": 35.6931268202,
    "lng": 128.4600972699
  },
  {
    "id": 71,
    "name": "부산성모안과병원(세광의료재단)",
    "address": "부산광역시 해운대구 해운대로409",
    "sido": "부산",
    "gugun": "해운대구",
    "phone": "1600-0775",
    "website": "https://sungmo.co.kr/",
    "lat": 35.1675369702,
    "lng": 129.1409690393
  },
  {
    "id": 72,
    "name": "부산하늘안과",
    "address": "부산 부산진구 중앙대로 736, 5층",
    "sido": "부산",
    "gugun": "부산진구",
    "phone": "051-803-9778",
    "website": "http://busanlasik.co.kr/",
    "lat": 35.1582022334,
    "lng": 129.0599295825
  },
  {
    "id": 73,
    "name": "부평드림안과",
    "address": "인천광역시 부평구 경원대로 1397, 파레스빌딩",
    "sido": "인천",
    "gugun": "부평구",
    "phone": "032-288-1515",
    "website": "http://dreamlasik.co.kr/",
    "lat": 37.491568515,
    "lng": 126.7245020734
  },
  {
    "id": 74,
    "name": "부평성모안과",
    "address": "인천광역시 부평구 경원대로1373 (부평동), 북인천우체국4층",
    "sido": "인천",
    "gugun": "부평구",
    "phone": "032-528-7288",
    "website": "https://www.inlasik.co.kr/main/",
    "lat": 37.4915364379,
    "lng": 126.7215423004
  },
  {
    "id": 75,
    "name": "부평열린안과의원",
    "address": "인천광역시 부평구 길주로 623 (굴포천역 8번출구 롯데마트 3층)",
    "sido": "인천",
    "gugun": "부평구",
    "phone": "032-267-7500",
    "website": "https://www.theopeneye.co.kr/",
    "lat": 37.5076994568,
    "lng": 126.7316279897
  },
  {
    "id": 76,
    "name": "비스타안과",
    "address": "부산광역시 해운대구 좌동순환로 505, 센트럴메디타워 11층",
    "sido": "부산",
    "gugun": "해운대구",
    "phone": "051-710-7100",
    "website": "http://www.vistaeye.co.kr/",
    "lat": 35.1656598502,
    "lng": 129.1640613039
  },
  {
    "id": 77,
    "name": "비앤빛안과",
    "address": "서울특별시 서초구 서초대로 411, GT타워 지하 2층",
    "sido": "서울",
    "gugun": "서초구",
    "phone": "1522-6800",
    "website": "https://www.bnviit.com/",
    "lat": 37.498108345,
    "lng": 127.0259226536
  },
  {
    "id": 78,
    "name": "빛사랑안과의원",
    "address": "서울 서대문구 신촌로 93 2층",
    "sido": "서울",
    "gugun": "서대문구",
    "phone": "02-323-5300",
    "website": "https://www.lasikindex.co.kr/",
    "lat": 37.555681783,
    "lng": 126.936566137
  },
  {
    "id": 79,
    "name": "삼성미라클안과",
    "address": "서울 강남구 테헤란로 115, 7층",
    "sido": "서울",
    "gugun": "강남구",
    "phone": "02-567-7775",
    "website": "https://www.samsungmiracle.co.kr/",
    "lat": 37.4990759,
    "lng": 127.0298871
  },
  {
    "id": 80,
    "name": "삼성미라클안과(천안)",
    "address": "충남 천안시 서북구 충무로 125",
    "sido": "충남",
    "gugun": "천안시 서북구",
    "phone": "041-576-0022",
    "website": "https://ca.samsungmiracle.co.kr/",
    "lat": 36.7926994026,
    "lng": 127.1213856153
  },
  {
    "id": 81,
    "name": "삼성스마일안과",
    "address": "대전광역시 서구 대덕대로 203, 미래빌딩 10층",
    "sido": "대전",
    "gugun": "서구",
    "phone": "042-476-0010",
    "website": "https://blog.naver.com/blasik",
    "lat": 36.3512439449,
    "lng": 127.3779275448
  },
  {
    "id": 82,
    "name": "삼성아이안과의원",
    "address": "서울특별시 강남구 테헤란로 105",
    "sido": "서울",
    "gugun": "강남구",
    "phone": "02-535-0075",
    "website": "http://www.samsungeye.com/html/main.php",
    "lat": 37.498636725,
    "lng": 127.0285297307
  },
  {
    "id": 83,
    "name": "삼성안과(See 삼성안과)",
    "address": "서울특별시 송파구 올림픽로 114, 서경빌딩 7층",
    "sido": "서울",
    "gugun": "송파구",
    "phone": "02-424-7523",
    "website": "http://www.topeye.co.kr/TE2/index.php",
    "lat": 37.5114114464,
    "lng": 127.0832071496
  },
  {
    "id": 84,
    "name": "삼성안과(산본)",
    "address": "경기도 군포시 산본로323번길 15 (산본동, 동산상가) 304, 305, 306, 307호",
    "sido": "경기",
    "gugun": "군포시",
    "phone": "031-348-8275",
    "website": "http://www.samsungeyes.com/",
    "lat": 37.3586377701,
    "lng": 126.9322485291
  },
  {
    "id": 85,
    "name": "새빛안과병원(세경의료재단)",
    "address": "경기도 고양시 일산동구 중앙로 1065 (백석동)",
    "sido": "경기",
    "gugun": "고양시 일산동구",
    "phone": "031-900-7700",
    "website": "https://www.saeviteye.com/",
    "lat": 37.6442717714,
    "lng": 126.7857414156
  },
  {
    "id": 86,
    "name": "새얀안과",
    "address": "서울특별시 종로구 삼일대로 395, 종로빌딩 3층",
    "sido": "서울",
    "gugun": "종로구",
    "phone": "02-735-3121",
    "website": "http://www.saeyan.com/",
    "lat": 37.5699036177,
    "lng": 126.9873599416
  },
  {
    "id": 87,
    "name": "서면좋은사람안과",
    "address": "부산광역시 부산진구 서면문화로 10, 영광도서 15~16층",
    "sido": "부산",
    "gugun": "부산진구",
    "phone": "051-711-6600",
    "website": "https://www.goodpersoneye.com/",
    "lat": 35.1588242914,
    "lng": 129.0576139122
  },
  {
    "id": 88,
    "name": "서부산성모안과",
    "address": "부산광역시 사하구 낙동남로1417, 락희빌딩8층",
    "sido": "부산",
    "gugun": "사하구",
    "phone": "051-206-2004",
    "website": "http://www.sungmoeye.com/",
    "lat": 35.1065663606,
    "lng": 128.9666291614
  },
  {
    "id": 89,
    "name": "서울글로우안과",
    "address": "서울특별시 노원구 노해로 507, 와우쇼핑몰 3층",
    "sido": "서울",
    "gugun": "노원구",
    "phone": "02-930-9306",
    "website": "http://gloweye.kr/",
    "lat": 37.6554272388,
    "lng": 127.0638890811
  },
  {
    "id": 90,
    "name": "서울삼성안과",
    "address": "서울특별시 광진구 천호대로670",
    "sido": "서울",
    "gugun": "광진구",
    "phone": "02-2201-2020",
    "website": "http://seoulsamsungec.com/",
    "lat": 37.5510907395,
    "lng": 127.0895889176
  },
  {
    "id": 91,
    "name": "서울삼성안과의원",
    "address": "서울특별시 강남구 청담동 80-4 송재빌딩 4",
    "sido": "서울",
    "gugun": "강남구",
    "phone": "02-511-9990",
    "website": "http://www.eyesamsung.co.kr/",
    "lat": 37.5266072233,
    "lng": 127.0440798845
  },
  {
    "id": 92,
    "name": "서울신세계안과",
    "address": "경기도 의정부시 태평로73번길55, 농협빌딩 지하1층",
    "sido": "경기",
    "gugun": "의정부시",
    "phone": "1599-7397",
    "website": "https://www.ssgeye.com/",
    "lat": 37.7388712801,
    "lng": 127.0484072508
  },
  {
    "id": 93,
    "name": "서울신세계안과 미아점",
    "address": "서울특별시 강북구 도봉로52, 와이스퀘어3~4층",
    "sido": "서울",
    "gugun": "강북구",
    "phone": "1599-7397",
    "website": "https://www.ssgeye.com/",
    "lat": 37.6136993726,
    "lng": 127.0305285261
  },
  {
    "id": 94,
    "name": "서울아이비안과(창원)",
    "address": "경상남도 창원시 성산구 상남로73 서울메디컬센터4층",
    "sido": "경남",
    "gugun": "창원시 성산구",
    "phone": "1577-5088",
    "website": "http://www.eyebest.co.kr/",
    "lat": 35.2206376696,
    "lng": 128.6798691027
  },
  {
    "id": 95,
    "name": "서울온안과의원",
    "address": "서울특별시 은평구 통일로 750, 경일빌딩 3~4층",
    "sido": "서울",
    "gugun": "은평구",
    "phone": "02-353-0112",
    "website": "https://oneye.co.kr/",
    "lat": 37.6123341514,
    "lng": 126.9286635024
  },
  {
    "id": 96,
    "name": "서창밝은안과",
    "address": "인천광역시 남동구 서창남순환로 223, 아페리온 A동 407호",
    "sido": "인천",
    "gugun": "남동구",
    "phone": "032-463-8275",
    "website": "http://www.scbeye.com/",
    "lat": 37.424820865,
    "lng": 126.7489212331
  },
  {
    "id": 97,
    "name": "성남센트럴안과",
    "address": "경기도 성남시 수정구 산성대로 267, 시네마타워 4층",
    "sido": "경기",
    "gugun": "성남시 수정구",
    "phone": "031-748-7779",
    "website": "http://snceye.co.kr/page/index.php",
    "lat": 37.4413240032,
    "lng": 127.1464467637
  },
  {
    "id": 98,
    "name": "성모진안과",
    "address": "서울특별시 서초구 강남대로337, 1/4/5층",
    "sido": "서울",
    "gugun": "서초구",
    "phone": "02-577-7782",
    "website": "https://www.jineye.co.kr/",
    "lat": 37.4965746,
    "lng": 127.0246219539
  },
  {
    "id": 99,
    "name": "세란안과",
    "address": "서울특별시 강남구 테헤란로87길29 (삼성동), M타워빌딩 2층/B1층",
    "sido": "서울",
    "gugun": "강남구",
    "phone": "02-552-0055",
    "website": "https://www.seraneye.com/",
    "lat": 37.5095900007,
    "lng": 127.0579906123
  },
  {
    "id": 100,
    "name": "세종우리성모안과",
    "address": "세종특별자치시 한누리대로273, 새롬시티6층",
    "sido": "세종",
    "gugun": "한누리대로273,",
    "phone": "044-864-3370",
    "website": "https://www.swseyes.com/",
    "lat": 36.4885263269,
    "lng": 127.2564850461
  },
  {
    "id": 101,
    "name": "센텀 소중한눈 안과",
    "address": "부산광역시 해운대구 센텀남대로50, 센텀임페리얼타워 14층",
    "sido": "부산",
    "gugun": "해운대구",
    "phone": "051-791-0011",
    "website": "https://sojunghannun.co.kr/",
    "lat": 35.1681088924,
    "lng": 129.1313013627
  },
  {
    "id": 102,
    "name": "센트럴강남성모안과의원",
    "address": "서울특별시 강동구 양재대로 1360 포레온스테이션5 2층 2079~2083호",
    "sido": "서울",
    "gugun": "강동구",
    "phone": "02-6954-2503",
    "website": "https://centraleyeclinic.com/",
    "lat": 37.527474781,
    "lng": 127.1370447003
  },
  {
    "id": 103,
    "name": "센트럴서울안과의원",
    "address": "서울특별시 용산구 이촌로224, 한강쇼핑센터2층",
    "sido": "서울",
    "gugun": "용산구",
    "phone": "02-792-0008",
    "website": "https://cseye.net/",
    "lat": 37.520145786,
    "lng": 126.9718771192
  },
  {
    "id": 104,
    "name": "셀러블153강남",
    "address": "서울시 강남구 언주로 720 . 펜트힐캐스케이드 B1층 ~ B3층",
    "sido": "서울",
    "gugun": "강남구",
    "phone": "1811-7153",
    "website": "http://cellable153.com/index.php",
    "lat": 37.5181217052,
    "lng": 127.0357076314
  },
  {
    "id": 105,
    "name": "수안과",
    "address": "서울특별시 강북구 도봉로 245, 수메디컬빌딩 2~3층/B1층",
    "sido": "서울",
    "gugun": "강북구",
    "phone": "02-988-1001",
    "website": "http://www.sooeye.co.kr/",
    "lat": 37.6303012518,
    "lng": 127.0242562834
  },
  {
    "id": 106,
    "name": "수연세안과의원",
    "address": "서울특별시 서초구 서초대로77길 54, 서초더블유타워 5층",
    "sido": "서울",
    "gugun": "서초구",
    "phone": "02-3477-0088",
    "website": "https://www.happylasek.com/",
    "lat": 37.502579825,
    "lng": 127.0248169009
  },
  {
    "id": 107,
    "name": "수정안과",
    "address": "부산광역시 북구 만덕대로5",
    "sido": "부산",
    "gugun": "북구",
    "phone": "051-331-7575",
    "website": "https://www.crystaleye.co.kr/",
    "lat": 35.2104829489,
    "lng": 129.0058285403
  },
  {
    "id": 108,
    "name": "시흥서울안과",
    "address": "경기도 시흥시 수인로3362, 태종빌딩7층",
    "sido": "경기",
    "gugun": "시흥시",
    "phone": "031-433-0007",
    "website": "https://siheungseye.co.kr/",
    "lat": 37.4406489154,
    "lng": 126.7854858946
  },
  {
    "id": 109,
    "name": "신세계안과(대구)",
    "address": "대구광역시 수성구 동대구로 311, 범어애플타워 7층",
    "sido": "대구",
    "gugun": "수성구",
    "phone": "053-742-5577",
    "website": "http://www.amarislasik.co.kr/",
    "lat": 35.8581242067,
    "lng": 128.6252371656
  },
  {
    "id": 110,
    "name": "신세계안과(울산)",
    "address": "울산광역시 남구 삼산로285",
    "sido": "울산",
    "gugun": "남구",
    "phone": "052-275-0001",
    "website": "http://www.lasikulsan.co.kr/",
    "lat": 35.5397627709,
    "lng": 129.3381092371
  },
  {
    "id": 111,
    "name": "신세계안과의원(부산)",
    "address": "부산광역시 부산진구 가야대로783-1, 3층",
    "sido": "부산",
    "gugun": "부산진구",
    "phone": "051-808-8288",
    "website": "https://www.cleareye.co.kr/",
    "lat": 35.1580155944,
    "lng": 129.0573430249
  },
  {
    "id": 112,
    "name": "실로암안과병원",
    "address": "서울특별시 강서구 등촌로181",
    "sido": "서울",
    "gugun": "강서구",
    "phone": "02-2650-0880",
    "website": "https://siloam.co.kr/",
    "lat": 37.5460169755,
    "lng": 126.8622398057
  },
  {
    "id": 113,
    "name": "심안과",
    "address": "대구광역시 달서구 월배로 218, 룩스빌딩 6층",
    "sido": "대구",
    "gugun": "달서구",
    "phone": "053-635-3600",
    "website": "http://www.simeye.co.kr/",
    "lat": 35.8184984755,
    "lng": 128.5373372789
  },
  {
    "id": 114,
    "name": "씨엘안과의원",
    "address": "대구광역시 중구 달구벌대로 2105 (덕산동96번지), 대구은행 7층",
    "sido": "대구",
    "gugun": "중구",
    "phone": "053-425-8575",
    "website": "https://www.new-eye.co.kr/",
    "lat": 35.8657726565,
    "lng": 128.5940346876
  },
  {
    "id": 115,
    "name": "아이닉안과의원",
    "address": "세종특별자치시 절재로 194 (어진동 103-21), 세종중앙타운 404호",
    "sido": "세종",
    "gugun": "절재로",
    "phone": "044-868-1288",
    "website": "https://sejongeye.com/",
    "lat": 36.5083073429,
    "lng": 127.2624450146
  },
  {
    "id": 116,
    "name": "아이러브안과의원",
    "address": "서울특별시 강남구 압구정로32길30 (신사동609-4)",
    "sido": "서울",
    "gugun": "강남구",
    "phone": "02-546-4848",
    "website": "https://www.iloveeye.co.kr/",
    "lat": 37.5257900767,
    "lng": 127.0297569918
  },
  {
    "id": 117,
    "name": "아이리움안과의원",
    "address": "서울특별시 강남구 강남대로 388, 강남센타빌딩 6~7층",
    "sido": "서울",
    "gugun": "강남구",
    "phone": "02-3420-2020",
    "website": "https://eyereum.com/",
    "lat": 37.4974495848,
    "lng": 127.0284225261
  },
  {
    "id": 118,
    "name": "아이백안과",
    "address": "대구광역시 중구 동덕로106-4, JH빌딩",
    "sido": "대구",
    "gugun": "중구",
    "phone": "053-763-1100",
    "website": "https://www.eye100.co.kr/",
    "lat": 35.8638858047,
    "lng": 128.6033198743
  },
  {
    "id": 119,
    "name": "아이봄안과의원",
    "address": "충청남도 아산시 배방읍 배방로14번길 9 5층 ( J,S메디컬)",
    "sido": "충남",
    "gugun": "아산시",
    "phone": "041-424-1275",
    "website": "http://eyebom.com/",
    "lat": 36.7752704,
    "lng": 127.0533465
  },
  {
    "id": 120,
    "name": "아이시티안과",
    "address": "부산광역시 부산진구 중앙대로 686, 경암빌딩 6층",
    "sido": "부산",
    "gugun": "부산진구",
    "phone": "051-817-0006",
    "website": "https://www.eyecity.co.kr/",
    "lat": 35.1539324032,
    "lng": 129.0595870977
  },
  {
    "id": 121,
    "name": "아이유안과의원",
    "address": "서울특별시 송파구 삼전로 84",
    "sido": "서울",
    "gugun": "송파구",
    "phone": "02-6951-1500",
    "website": "https://www.iueye.co.kr/",
    "lat": 37.505886184,
    "lng": 127.0897730557
  },
  {
    "id": 122,
    "name": "아이존안과의원",
    "address": "부산광역시 부산진구 범일로 152",
    "sido": "부산",
    "gugun": "부산진구",
    "phone": "051-643-2740",
    "website": "http://www.ijon.co.kr/",
    "lat": 35.1435808293,
    "lng": 129.0595818108
  },
  {
    "id": 123,
    "name": "아이플러스안과",
    "address": "서울특별시 서초구 강남대로 435, 주류성빌딩 5층",
    "sido": "서울",
    "gugun": "서초구",
    "phone": "02-3482-2020",
    "website": "https://www.seouleyeplus.com/",
    "lat": 37.5011776112,
    "lng": 127.0255610305
  },
  {
    "id": 124,
    "name": "아인스안과",
    "address": "경상남도 창원시 마산회원구 3·15대로 778, 산호당약국 3층",
    "sido": "경남",
    "gugun": "창원시 마산회원구",
    "phone": "055-294-7442",
    "website": "http://einseye.com/",
    "lat": 35.2407749782,
    "lng": 128.584699184
  },
  {
    "id": 125,
    "name": "아임아인안과의원",
    "address": "인천광역시 미추홀구 경인로 372",
    "sido": "인천",
    "gugun": "미추홀구",
    "phone": "032-719-8813",
    "website": "http://eye.immed.co.kr/main",
    "lat": 37.4580053,
    "lng": 126.681187
  },
  {
    "id": 126,
    "name": "안견안과의원",
    "address": "대구광역시 수성구 청수로156, 3~4층",
    "sido": "대구",
    "gugun": "수성구",
    "phone": "053-766-8875",
    "website": "http://www.akeye.co.kr/",
    "lat": 35.8392654501,
    "lng": 128.6209008539
  },
  {
    "id": 127,
    "name": "알파서울안과의원",
    "address": "경기도 성남시 분당구 판교역로 152, 알파돔타워 B1층 3~5호",
    "sido": "경기",
    "gugun": "성남시 분당구",
    "phone": "1544-5199",
    "website": "https://alphaeyeclinic.com/",
    "lat": 37.3942454075,
    "lng": 127.1103068124
  },
  {
    "id": 129,
    "name": "압구정성모안과",
    "address": "서울특별시 강남구 언주로 859, 쉬즈에비뉴빌딩 B1, 1, M, 2, 5층",
    "sido": "서울",
    "gugun": "강남구",
    "phone": "02-3445-3457",
    "website": "https://www.smecdoc.co.kr/",
    "lat": 37.5271890706,
    "lng": 127.0331118713
  },
  {
    "id": 130,
    "name": "압구정안과(서초)클리닉",
    "address": "서울특별시 서초구 강남대로597, 3~4층",
    "sido": "서울",
    "gugun": "서초구",
    "phone": "02-3416-1001",
    "website": "https://agjeye.com/",
    "lat": 37.5150359818,
    "lng": 127.0193176589
  },
  {
    "id": 131,
    "name": "압구정에스앤비안과의원",
    "address": "서울특별시 강남구 논현로842, 압구정빌딩9층",
    "sido": "서울",
    "gugun": "강남구",
    "phone": "02-3446-6666",
    "website": "https://snbeye.com/",
    "lat": 37.5240379714,
    "lng": 127.0287309228
  },
  {
    "id": 132,
    "name": "에스엔유(SNU) 안과(신사동)",
    "address": "서울특별시 강남구 강남대로624 (신사동502-6), ICT타워3층",
    "sido": "서울",
    "gugun": "강남구",
    "phone": "02-548-0201",
    "website": "https://www.snuseoul.com/",
    "lat": 37.5175038907,
    "lng": 127.0195008643
  },
  {
    "id": 133,
    "name": "엘앤케이(L&K) 미래안과",
    "address": "경기 수원시 영통구 봉영로 1590 밀레니엄프라자 302호",
    "sido": "경기",
    "gugun": "수원시 영통구",
    "phone": "031-204-5055",
    "website": "http://www.miraelasik.com/",
    "lat": 37.2527609765,
    "lng": 127.0734441047
  },
  {
    "id": 134,
    "name": "엠에스(MS)안과(반포)",
    "address": "서울시 서초구 신반포로 189 쇼핑타운 4동 2층",
    "sido": "서울",
    "gugun": "서초구",
    "phone": "02-6949-3322",
    "website": "https://mseyesclinic.com/bbs/content.php?co_id=info_029",
    "lat": 37.506545494,
    "lng": 127.0048678022
  },
  {
    "id": 135,
    "name": "연세 안과(제주)",
    "address": "제주특별자치도 서귀포시 일주동로 8675",
    "sido": "제주",
    "gugun": "서귀포시",
    "phone": "064-762-0727",
    "website": "http://syonsei.com/",
    "lat": 33.2530177709,
    "lng": 126.5616894086
  },
  {
    "id": 136,
    "name": "연세바른안과의원",
    "address": "인천광역시 부평구 부평문화로 87, 로로메디칼타워 4층 405~408호",
    "sido": "인천",
    "gugun": "부평구",
    "phone": "032-504-7900",
    "website": "http://ysbaruneye.com/",
    "lat": 37.4944745714,
    "lng": 126.7258777715
  },
  {
    "id": 137,
    "name": "연세봄안과",
    "address": "경기도 하남시 미사강변동로 100-1, 파라곤스퀘어 6층",
    "sido": "경기",
    "gugun": "하남시",
    "website": "http://bomeye.com/",
    "lat": 37.5639612579,
    "lng": 127.1936000962
  },
  {
    "id": 138,
    "name": "연세솔안과",
    "address": "서울특별시 강서구 화곡로68길 3, 영스퀘어 6층",
    "sido": "서울",
    "gugun": "강서구",
    "phone": "02-3663-0345",
    "website": "https://yonseisoleye.com/",
    "lat": 37.5595836718,
    "lng": 126.8547378527
  },
  {
    "id": 139,
    "name": "연세안과의원",
    "address": "서울특별시 양천구 신정중앙로 103",
    "sido": "서울",
    "gugun": "양천구",
    "phone": "02-2065-0075",
    "website": "http://www.4youreye.com/",
    "lat": 37.5265545139,
    "lng": 126.8634355215
  },
  {
    "id": 140,
    "name": "연세장안과의원",
    "address": "서울시 서대문구 수색로 56",
    "sido": "서울",
    "gugun": "서대문구",
    "phone": "02-372-5677",
    "website": "https://blog.naver.com/PostList.naver?blogId=yonseijangeye&categoryNo=9",
    "lat": 37.5709038651,
    "lng": 126.9122532898
  },
  {
    "id": 141,
    "name": "연세플러스안과(성남)",
    "address": "경기도 성남시 분당구 성남대로 168, 미도프라자 5층",
    "sido": "경기",
    "gugun": "성남시 분당구",
    "phone": "1599-5822",
    "website": "https://pluseye.co.kr/",
    "lat": 37.3508873919,
    "lng": 127.1094924495
  },
  {
    "id": 142,
    "name": "연수김안과",
    "address": "인천광역시 연수구 컨벤시아대로 165, 포스코타워송도 5층",
    "sido": "인천",
    "gugun": "연수구",
    "phone": "032-812-1001",
    "website": "https://www.kimeye.com/",
    "lat": 37.3891408886,
    "lng": 126.6444426769
  },
  {
    "id": 143,
    "name": "연수늘밝은안과",
    "address": "인천광역시 연수구 청능대로 210, 스퀘어원 3층 (동춘동)",
    "sido": "인천",
    "gugun": "연수구",
    "phone": "032-456-4370",
    "website": "http://www.brightlasik21.co.kr/",
    "lat": 37.405998163,
    "lng": 126.6836220604
  },
  {
    "id": 144,
    "name": "연수스마트안과",
    "address": "인천광역시 연수구 청능대로103, BYC빌딩 4층 402호",
    "sido": "인천",
    "gugun": "연수구",
    "phone": "032-816-1002",
    "website": "https://smarteyecenter.co.kr/",
    "lat": 37.4136398589,
    "lng": 126.6762653094
  },
  {
    "id": 145,
    "name": "예본안과의원",
    "address": "서울특별시 종로구 종로78, 미려빌딩 2층 210호 (종로2가)",
    "sido": "서울",
    "gugun": "종로구",
    "phone": "02-737-0030",
    "website": "http://www.yebon.com/",
    "lat": 37.5698795927,
    "lng": 126.9860413349
  },
  {
    "id": 146,
    "name": "예일안과의원",
    "address": "경상남도 창원시 마산회원구 3·15대로 659 (석전동)",
    "sido": "경남",
    "gugun": "창원시 마산회원구",
    "phone": "055-296-6111",
    "website": "https://yeileyeclinic.com/",
    "lat": 35.2320669358,
    "lng": 128.5771848789
  },
  {
    "id": 147,
    "name": "온누리스마일안과",
    "address": "서울특별시 서초구 서초대로77길3, 아라타워B2",
    "sido": "서울",
    "gugun": "서초구",
    "phone": "02-543-8800",
    "website": "https://www.onnurismile.com/",
    "lat": 37.498060913,
    "lng": 127.0265048075
  },
  {
    "id": 148,
    "name": "올림안과의원",
    "address": "서울특별시 강남구 논현로 546, 리안빌딩 2~5층",
    "sido": "서울",
    "gugun": "강남구",
    "phone": "02-511-7575",
    "website": "https://ollimeye.com/",
    "lat": 37.5048885082,
    "lng": 127.0352959882
  },
  {
    "id": 149,
    "name": "올바른안과의원",
    "address": "경기도 수원시 영통구 광교중앙로 145",
    "sido": "경기",
    "gugun": "수원시 영통구",
    "phone": "031-216-7588",
    "website": "http://allbaruneye.com/",
    "lat": 37.2870804047,
    "lng": 127.0577744248
  },
  {
    "id": 150,
    "name": "와이비(YB)안과의원(수원)",
    "address": "경기도 수원시 팔달구 권광로181, 씨네파크",
    "sido": "경기",
    "gugun": "수원시 팔달구",
    "phone": "031-224-1120",
    "website": "http://www.yblasik.com/",
    "lat": 37.2637484873,
    "lng": 127.0322210167
  },
  {
    "id": 151,
    "name": "우리눈안과",
    "address": "경상북도 포항시 남구 중흥로 92, 2~3층",
    "sido": "경북",
    "gugun": "포항시 남구",
    "phone": "054-278-1036",
    "website": "https://woorinoon.com/",
    "lat": 36.0131676002,
    "lng": 129.3498035885
  },
  {
    "id": 152,
    "name": "우리안과",
    "address": "서울특별시 송파구 올림픽로 106 (잠실동)",
    "sido": "서울",
    "gugun": "송파구",
    "phone": "02-514-7582",
    "lat": 37.511396227,
    "lng": 127.0825542804
  },
  {
    "id": 153,
    "name": "우리안과의원",
    "address": "대전광역시 서구 둔산동 1034, 갤러리아백화점 별관 5층",
    "sido": "대전",
    "gugun": "서구",
    "phone": "042-476-1675",
    "website": "https://www.woorieye.co.kr/",
    "lat": 36.3526520135,
    "lng": 127.3787299066
  },
  {
    "id": 154,
    "name": "울산밝은안과",
    "address": "울산광역시 남구 삼산로274, W센터6층",
    "sido": "울산",
    "gugun": "남구",
    "phone": "052-266-8800",
    "website": "https://blog.naver.com/gumijinclinic",
    "lat": 35.5389435517,
    "lng": 129.3371324152
  },
  {
    "id": 155,
    "name": "울산성모안과의원",
    "address": "울산광역시 남구 삼산로 201",
    "sido": "울산",
    "gugun": "남구",
    "phone": "052-275-0775",
    "website": "https://www.sungmoeye.co.kr/",
    "lat": 35.5380804417,
    "lng": 129.329176365
  },
  {
    "id": 156,
    "name": "월배이노안과의원",
    "address": "대구광역시 달서구 월배로 100, 2층",
    "sido": "대구",
    "gugun": "달서구",
    "phone": "053-643-1004",
    "website": "http://www.innoeye.co.kr/",
    "lat": 35.8140521571,
    "lng": 128.5254844567
  },
  {
    "id": 157,
    "name": "유밸 안과(인천중구)",
    "address": "인천광역시 중구 우현로90",
    "sido": "인천",
    "gugun": "중구",
    "phone": "080-762-0088",
    "website": "https://ubaleye.com/",
    "lat": 37.4746453482,
    "lng": 126.6311141536
  },
  {
    "id": 158,
    "name": "유성안과",
    "address": "대전광역시 유성구 계룡로 105",
    "sido": "대전",
    "gugun": "유성구",
    "phone": "1588-7655",
    "website": "http://www.yuseongeye.com",
    "lat": 36.3537401346,
    "lng": 127.34239955
  },
  {
    "id": 160,
    "name": "의정부서울안과",
    "address": "경기도 의정부시 평화로 635",
    "sido": "경기",
    "gugun": "의정부시",
    "phone": "031-877-8800",
    "website": "https://www.seoul-eye.co.kr/",
    "lat": 37.7486663316,
    "lng": 127.0447866592
  },
  {
    "id": 161,
    "name": "이노안과의원",
    "address": "대구광역시 달서구 월곡로 260 상인프라자 5층",
    "sido": "대구",
    "gugun": "달서구",
    "phone": "053-632-6800",
    "website": "http://www.innoeye.co.kr/",
    "lat": 35.817758,
    "lng": 128.5307084
  },
  {
    "id": 162,
    "name": "이성수안과",
    "address": "경상남도 진주시 진주대로 863",
    "sido": "경남",
    "gugun": "진주시",
    "phone": "055-746-6000",
    "website": "https://www.lasik114.com/",
    "lat": 35.1776583234,
    "lng": 128.0914499923
  },
  {
    "id": 163,
    "name": "이안과병원(의료법인청운의료재단)",
    "address": "대전광역시 중구 대종로 468 (대흥동), 9층",
    "sido": "대전",
    "gugun": "중구",
    "phone": "042-220-5500",
    "website": "https://www.2eyes.or.kr/",
    "lat": 36.3263385973,
    "lng": 127.4276352783
  },
  {
    "id": 164,
    "name": "이안안과",
    "address": "서울특별시 중구 통일로 10, 연세대학교 세브란스빌딩 1층",
    "sido": "서울",
    "gugun": "중구",
    "phone": "02-319-0012",
    "website": "http://ianeye.co.kr/",
    "lat": 37.5570966597,
    "lng": 126.9736337612
  },
  {
    "id": 165,
    "name": "잠실서울밝은안과의원",
    "address": "서울특별시 송파구 송파대로 422, 영빌딩 3층",
    "sido": "서울",
    "gugun": "송파구",
    "phone": "02-416-0075",
    "website": "https://www.goodlasik.co.kr/",
    "lat": 37.5049872637,
    "lng": 127.1078538305
  },
  {
    "id": 166,
    "name": "제이린안과",
    "address": "부산광역시 부산진구 중앙대로 672",
    "sido": "부산",
    "gugun": "부산진구",
    "phone": "051-710-1004",
    "website": "https://jryneye.com/",
    "lat": 35.1530062217,
    "lng": 129.0596063204
  },
  {
    "id": 167,
    "name": "제일연세안과(수원)",
    "address": "경기도 수원시 팔달구 팔달로 3가 101-3, 2층",
    "sido": "경기",
    "gugun": "수원시 팔달구",
    "phone": "031-251-0001",
    "website": "http://jeileye.net/",
    "lat": 37.2765932882,
    "lng": 127.0150192445
  },
  {
    "id": 168,
    "name": "좋은사람들성모안과",
    "address": "서울특별시 성동구 왕십리로 315, 한동타워 7층",
    "sido": "서울",
    "gugun": "성동구",
    "phone": "02-556-6551",
    "website": "https://www.jouneye.com/",
    "lat": 37.5617210789,
    "lng": 127.0342376979
  },
  {
    "id": 169,
    "name": "좋은의사들안과병원(울산)",
    "address": "울산광역시 남구 삼산로 213",
    "sido": "울산",
    "gugun": "남구",
    "phone": "052-276-3500",
    "website": "http://gdeyeus.co.kr/",
    "lat": 35.5383028249,
    "lng": 129.330397647
  },
  {
    "id": 170,
    "name": "지에스(GS)안과",
    "address": "서울 강남구 강남대로 390 미진프라자, 8층/15~16층",
    "sido": "서울",
    "gugun": "강남구",
    "phone": "02-3469-0900",
    "website": "https://www.gseyecenter.com/",
    "lat": 37.4977553719,
    "lng": 127.0280872394
  },
  {
    "id": 171,
    "name": "진안과",
    "address": "경상북도 구미시 구미중앙로 85, 3층 1호 (원평동)",
    "sido": "경북",
    "gugun": "구미시",
    "phone": "054-453-6989",
    "website": "http://www.lasikgumi.co.kr/",
    "lat": 36.1288363045,
    "lng": 128.3322508744
  },
  {
    "id": 172,
    "name": "첫눈애안과",
    "address": "서울 강남구 테헤란로 332 (역삼동, HJ타워) 5층",
    "sido": "서울",
    "gugun": "강남구",
    "phone": "02-576-0022",
    "website": "https://www.1st-eye.com/ko",
    "lat": 37.5039255182,
    "lng": 127.0482736997
  },
  {
    "id": 173,
    "name": "청주김안과",
    "address": "충청북도 청주시 서원구 사직대로 88",
    "sido": "충북",
    "gugun": "청주시 서원구",
    "phone": "043-268-4131",
    "website": "https://kimsclinic.co.kr/",
    "lat": 36.6344522812,
    "lng": 127.4571453564
  },
  {
    "id": 174,
    "name": "청춘안과",
    "address": "부산광역시 동래구 명륜로103번길19",
    "sido": "부산",
    "gugun": "동래구",
    "phone": "051-558-0111",
    "website": "http://www.youngeye.co.kr/",
    "lat": 35.2029262415,
    "lng": 129.08200157
  },
  {
    "id": 175,
    "name": "최안과의원",
    "address": "경상남도 김해시 가락로 19, 메디칼센터 7~8층",
    "sido": "경남",
    "gugun": "김해시",
    "phone": "055-723-7582",
    "website": "http://www.choieye.com/",
    "lat": 35.2283323869,
    "lng": 128.88219863
  },
  {
    "id": 176,
    "name": "춘천드림아이안과",
    "address": "강원도 춘천시 방송길98",
    "sido": "강원",
    "gugun": "춘천시",
    "phone": "033-241-0025",
    "website": "https://blog.naver.com/ccdreameye",
    "lat": 37.8679385883,
    "lng": 127.7201522341
  },
  {
    "id": 177,
    "name": "충주성모안과",
    "address": "충청북도 충주시 중앙로 33, 1층/4층",
    "sido": "충북",
    "gugun": "충주시",
    "phone": "043-848-6733",
    "website": "http://maryeye.co.kr/",
    "lat": 36.9731414383,
    "lng": 127.9269622782
  },
  {
    "id": 178,
    "name": "클리어서울안과",
    "address": "서울특별시 서초구 서초대로77길17, 6층",
    "sido": "서울",
    "gugun": "서초구",
    "phone": "02-599-7779",
    "website": "https://clearseouleye.com/",
    "lat": 37.4995535963,
    "lng": 127.0257523889
  },
  {
    "id": 179,
    "name": "클리어안과의원",
    "address": "경기도 평택시 지제동삭2로 181-26, 4~5층",
    "sido": "경기",
    "gugun": "평택시",
    "phone": "031-647-6247",
    "website": "http://cleareyeclinic.co.kr/",
    "lat": 37.0172169773,
    "lng": 127.0941212329
  },
  {
    "id": 180,
    "name": "타임안과",
    "address": "서울특별시 구로구 경인로387, 5층",
    "sido": "서울",
    "gugun": "구로구",
    "phone": "02-6342-8000",
    "website": "https://timeeyeclinic.co.kr/",
    "lat": 37.4970868505,
    "lng": 126.8631425945
  },
  {
    "id": 181,
    "name": "태안과(노원)",
    "address": "서울특별시 노원구 동일로1547 동남빌딩",
    "sido": "서울",
    "gugun": "노원구",
    "phone": "02-939-7733",
    "website": "http://www.tae-eye.com/",
    "lat": 37.6665575614,
    "lng": 127.0569313843
  },
  {
    "id": 182,
    "name": "파티마안과",
    "address": "경상남도 창원시 성산구 원이대로320, 더 시티세븐 트레이드센터4층",
    "sido": "경남",
    "gugun": "창원시 성산구",
    "phone": "1566-5575",
    "website": "http://www.fatimalasik.co.kr/",
    "lat": 35.239666844,
    "lng": 128.6544086923
  },
  {
    "id": 184,
    "name": "퍼스트삼성안과",
    "address": "서울특별시 서초구 서초대로78길22, 5층",
    "sido": "서울",
    "gugun": "서초구",
    "phone": "1661-1191",
    "website": "http://firstsamsung.co.kr/",
    "lat": 37.4958057253,
    "lng": 127.02754743
  },
  {
    "id": 185,
    "name": "퍼스트성모안과",
    "address": "서울특별시 노원구 동일로 1405, 8층",
    "sido": "서울",
    "gugun": "노원구",
    "phone": "02-6956-8011",
    "website": "https://www.firstsamsung.com/",
    "lat": 37.6538310279,
    "lng": 127.0601778751
  },
  {
    "id": 186,
    "name": "퍼스트안과의원",
    "address": "부산광역시 중구 구덕로5, 은과빛메디컬빌딩6~7층",
    "sido": "부산",
    "gugun": "중구",
    "phone": "1670-1552",
    "website": "https://bsfirst.co.kr/",
    "lat": 35.0975517378,
    "lng": 129.0349777132
  },
  {
    "id": 187,
    "name": "푸른안과(전주)",
    "address": "전라북도 전주시 덕진구 백제대로 660 (금암동)",
    "sido": "전북",
    "gugun": "전주시 덕진구",
    "phone": "063-278-2121",
    "website": "http://www.seenew.co.kr/",
    "lat": 35.8429260614,
    "lng": 127.1413788189
  },
  {
    "id": 188,
    "name": "하나서울안과의원",
    "address": "경기도 부천시 원미구 길주로181, 골든벨타워2층",
    "sido": "경기",
    "gugun": "부천시 원미구",
    "phone": "032-328-0071",
    "website": "https://www.hanaeye.co.kr/",
    "lat": 37.5053155548,
    "lng": 126.7626344717
  },
  {
    "id": 189,
    "name": "하늘안과(송도)",
    "address": "인천광역시 연수구 컨벤시아대로130번길14, 플러스메디타워301호",
    "sido": "인천",
    "gugun": "연수구",
    "phone": "032-833-0790",
    "website": "https://www.songdoskyeye.com/",
    "lat": 37.3929624167,
    "lng": 126.6447256935
  },
  {
    "id": 190,
    "name": "하늘안과의원",
    "address": "서울특별시 서초구 강남대로 509 (반포동), 1,2,6,8,9,10층 / B1~B3",
    "sido": "서울",
    "gugun": "서초구",
    "phone": "02-573-9779",
    "website": "https://www.bweye.co.kr/",
    "lat": 37.5076567501,
    "lng": 127.0214717385
  },
  {
    "id": 191,
    "name": "하이뷰안과",
    "address": "부산광역시 부산진구 가야대로767-1, 원광메디컬센터2~3층",
    "sido": "부산",
    "gugun": "부산진구",
    "phone": "051-816-0001",
    "website": "https://www.hivue.co.kr/",
    "lat": 35.158004004,
    "lng": 129.0556427864
  },
  {
    "id": 192,
    "name": "하이안과",
    "address": "서울특별시 강남구 도산대로119 (신사동), K타워3층",
    "sido": "서울",
    "gugun": "강남구",
    "phone": "02-540-5377",
    "website": "http://hieye.co.kr/",
    "lat": 37.5173261424,
    "lng": 127.0214654126
  },
  {
    "id": 193,
    "name": "한길안과병원(한길의료재단)",
    "address": "인천 부평구 부평대로 35",
    "sido": "인천",
    "gugun": "부평구",
    "phone": "1577-7117",
    "website": "https://www.hangileye.co.kr/",
    "lat": 37.4915720866,
    "lng": 126.7254945334
  },
  {
    "id": 194,
    "name": "한빛안과",
    "address": "대구광역시 중구 달구벌대로2109, 교원빌딩3층",
    "sido": "대구",
    "gugun": "중구",
    "phone": "053-423-2367",
    "website": "http://eyeok.co.kr/",
    "lat": 35.8656732545,
    "lng": 128.5946257613
  },
  {
    "id": 195,
    "name": "혜안서울안과",
    "address": "서울특별시 강남구 테헤란로 528, 슈페리어타워 4층",
    "sido": "서울",
    "gugun": "강남구",
    "phone": "02-2051-0500",
    "website": "https://www.heaaneye.com/",
    "lat": 37.5080952687,
    "lng": 127.0620024215
  },
  {
    "id": 196,
    "name": "효안과의원",
    "address": "대전광역시 서구 대덕대로 175번길 16, 효안과 빌딩 7,8,9층",
    "sido": "대전",
    "gugun": "서구",
    "phone": "042-486-5050",
    "website": "http://www.invisionclinic.co.kr/",
    "lat": 36.3496739509,
    "lng": 127.3762893578
  },
  {
    "id": 197,
    "name": "힐링안과",
    "address": "서울특별시 강남구 강남대로 470, 10-11층",
    "sido": "서울",
    "gugun": "강남구",
    "phone": "02-566-1222",
    "website": "https://www.healingeye.co.kr/",
    "lat": 37.5043291659,
    "lng": 127.0250609759
  }
];
